'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _auth = require('./auth');

var _auth2 = _interopRequireDefault(_auth);

var _customers = require('./customers');

var _customers2 = _interopRequireDefault(_customers);

var _cameras = require('./cameras');

var _cameras2 = _interopRequireDefault(_cameras);

var _firmware = require('./firmware');

var _firmware2 = _interopRequireDefault(_firmware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import multireducer from 'multireducer';
exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxAsyncConnect.reducer,
  auth: _auth2.default,
  customers: _customers2.default,
  cameras: _cameras2.default,
  firmware: _firmware2.default
});
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/reducer.js
 ** module id = 1404
 ** module chunks = 0
 **/